import { Alert, AlertSection } from '@aloft/toolkit-shared';

import {
  toCommentaryTargetCellKey,
  toReconciliationTargetCellKey,
} from './requiredFieldFocus.ts';

export const getActiveAlertForRequiredField = (
  alertsPerSection: Record<AlertSection, Alert[]>,
  fieldName: string,
): Alert | undefined => {
  const targetCellKeys = new Set([
    toReconciliationTargetCellKey(fieldName),
    toCommentaryTargetCellKey(fieldName),
  ]);

  return Object.values(alertsPerSection)
    .flat()
    .find(
      (alert) =>
        alert.fixingInfo.targetCellKey && targetCellKeys.has(alert.fixingInfo.targetCellKey),
    );
};
